import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import React from "react";
import AddCategory from "../../Modals/addcategory";

const LoyaltyPoints = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [rows, setRows] = useState([
    {
      id: 1,
      country: "United States",
      currency: "USD",
      valueOfPoint: 0.01,
      status: true,
    },
    {
      id: 2,
      country: "India",
      currency: "INR",
      valueOfPoint: 0.75,
      status: false,
    },
    {
      id: 3,
      country: "United Kingdom",
      currency: "GBP",
      valueOfPoint: 0.008,
      status: true,
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Loyalty Points Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Loyalty Points Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search by country or currency..."
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("add")}>
              <AddIcon /> Add Loyalty Point
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell>Value of 1 Point</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows
                .filter(
                  (row) =>
                    row.country.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    row.currency.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.country}</TableCell>
                    <TableCell>{row.currency}</TableCell>
                    <TableCell>{row.valueOfPoint}</TableCell>
                    <TableCell>
                      <SwitchToggle />
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => navigate("add")}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddCategory open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default LoyaltyPoints;
